import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../authContext"
import { getMyUser } from "../../services/AuthServices"
import { Spin } from "antd"

const ActiveUserGuard = ({ children }) => {
    const { currentUser, getToken } = useAuth()
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const checkUserActive = async () => {
            if (!currentUser) {
                navigate("/login")
                return
            }

            try {
                const token = await getToken()
                if (!token) {
                    navigate("/login")
                    return
                }
                const userData = await getMyUser(token)

                if (!userData.active) {
                    navigate("/preconfirmacion")
                    return
                }

                if (!userData.veterinary.id || !userData.veterinary.name) {
                    navigate("/preconfirmacion")
                    return
                }

                else if (!userData.phoneNumber || !userData.reportCustomization.displayName || !userData.reportCustomization.signature || !userData.reportCustomization.license) {
                    navigate("/postconfirmacion")
                    return
                }

                setIsLoading(false)
            } catch (error) {
                console.error("Error checking user status:", error)
                navigate("/login")
            }
        }

        checkUserActive()
    }, [currentUser, navigate, getToken])

    if (isLoading) {
        return (
            <div className="admin-loading-screen">
                <Spin size="large" />
            </div>
        );
    }

    return children
}

export default ActiveUserGuard
